module.exports = __webpack_public_path__ + "img/floating-image-1.b03eded7.png";